export default __webpack_public_path__ + "static/media/study_material.55e7755f.svg";